import { useState, useEffect }      from 'react';
import Textfield                    from 'app/common/uikit/textfield';
import { 
    useInvoiceQuery, 
    useGetAccessToken
}                                   from '../../services/query';
import { 
    useSelector,
    shallowEqual
}                                   from "react-redux";
import SearchError                  from '../query-form/components/search-error';

const QueryForm = props => {
    const r 			            = useSelector(state => ({
        accessToken     : state.provider.accessToken,
        customer        : state.provider.customer,
    }), shallowEqual);

    const [ s, setState ]                   = useState({
        customerIdentity    : null,
        invoiceNumber       : null,
        amount              : null,
        outputType          : 'Html',
        includeInvoiceBinaryData: true,
        compressedBinaryData: false
    })

    const [ modalState, setModalState ] = useState({
        showSearchError            : false,
    })

    const accessTokenHandler    = useGetAccessToken();
    const invoiceQueryHandler   = useInvoiceQuery();

    const toggleModal = (modal, status) => {
        setModalState(prevState => ({
            ...prevState,
            [modal]: status
        }))
    }

    const updateFormData = (node, value) => {
        setState(prevState => ({
            ...prevState,
            [node]: value
        }))
    }

    const renderModal = () => {
        if (modalState.showSearchError)
            return <SearchError closeModal={ () => toggleModal('showSearchError', false) } />
    }

    const getAccessToken = () => {
        accessTokenHandler.mutate({
            customerIdentity    : s.customerIdentity,
            eMail               : 'ws@7330354914.com',//window.REACT_APP_SERVICE_USERNAME || process?.env?.REACT_APP_SERVICE_USERNAME,
            password            : 'pr@teL34@Ws',//window.REACT_APP_SERVICE_PASSWORD || process?.env?.REACT_APP_SERVICE_PASSWORD
        })
    }

    const validateCustomerInfo = () => {
        return s.customerIdentity === r.customer.loggedCustomerIdentity;
    }

    const startQuery = () => {
        if (!accessTokenHandler.data)
            return getAccessToken();

        findInvoice();
    }

    const findInvoice = () => {
        if (validateCustomerInfo()) {
            invoiceQueryHandler.mutate({
                accessToken : r.accessToken,
                amount      : s.amount,
                data        : {
                    invoiceNumber           : s.invoiceNumber,
                    outputType              : 'Html',
                    includeInvoiceBinaryData: true,
                    compressedBinaryData    : false,
                },
                callback: () => {
                    toggleModal('showSearchError', true);
                }
            })
        }        
    }

    useEffect(() => {
        if (accessTokenHandler.isSuccess)
            findInvoice();
    // eslint-disable-next-line react-hooks/exhaustive-deps    
    }, [ accessTokenHandler.isSuccess])

    useEffect(() => {
        if (invoiceQueryHandler.isError)
            toggleModal('showSearchError', true);
    }, [ invoiceQueryHandler.isError ])

    return (
        <div id="query-form-wrapper">
            { renderModal() }
            <div className="query-form-container">
                <div className="query-form-container-header">
                    <div className="icon reciept" />
                    E-Arşiv Fatura Sorgulama
                </div>
                <div className="query-form-container-content">
                    <div className="info-box">Bu sorgulama sadece e-arşiv sisteminde kayıtlı faturalar için geçerlidir.</div>
                    <div className="form-container">
                        <div className="form-container-row">
                            <Textfield
                                attrs       = {{
                                    id: 'customerIdentity',
                                    name: 'customerIdentity',
                                    tabIndex: 1,
                                    maxLength: 11,
                                }}
                                label       = { 'Satıcı VKN / TCKN' }
                                onChange    = { value => updateFormData('customerIdentity', value )}
                                value       = { s.customerIdentity }
                                type        = { 'number' }
                                fieldName   = { 'customerIdentity' }
                                placeholder = { 'Kimlik numarası' }
                                errors      = { [] }
                            />                            
                        </div>
                        <div className="form-container-row">
                            <Textfield
                                attrs       = {{
                                    id: 'invoiceNumber',
                                    name: 'invoiceNumber',
                                    tabIndex: 2,
                                    maxLength: 16
                                }}
                                label       = { 'Fatura Numarası' }
                                onChange    = { value => updateFormData('invoiceNumber', value )}
                                value       = { s.invoiceNumber }
                                fieldName   = { 'invoiceNumber' }
                                placeholder = { '16 haneli fatura numarası' }
                                errors      = { [] }
                            />                            
                        </div>
                        <div className="form-container-row">
                            <Textfield
                                attrs       = {{
                                    id: 'amount',
                                    name: 'amount',
                                    tabIndex: 3
                                }}
                                label       = { 'Ödenecek Tutar' }
                                onChange    = { value => updateFormData('amount', value )}
                                value       = { s.amount }
                                fieldName   = { 'amount' }
                                type        = { 'number' }
                                errors      = { [] }
                            />                            
                        </div>
                    </div>
                </div>
                <div className="query-form-container-info">
                    <div className="info-box">Fatura Sorgulamasında Dikkat Edilecek Hususlar</div>
                    <ul>
                        <li>
                            <div className="icon circle flat" />
                            Sorguladığınız faturanın e-Arşiv Uygulaması kapsamında düzenlenip düzenlenmediğinden emin olunuz. (e-Arşiv kapsamında fatura düzenlemeye yetkili mükellefler e-Arşiv Uygulamasına Kayıtlı Mükellefler Listesi duyurulmaktadır.)
                        </li>
                        <li>
                            <div className="icon circle flat" />
                            Faturanızı düzenleyen mükellefin Vergi Kimlik Numarası/TC Kimlik Numarası bilgilerinin doğru girdiğinizden emin olunuz.
                        </li>
                        <li>
                            <div className="icon circle flat" />
                            Fatura üzerinde yer alan Fatura numarasının doğru bir şekilde girildiğinden emin olunuz.
                        </li>
                        <li>
                            <div className="icon circle flat" />
                            Faturalar üzerinde ödenecek tutar ile genel toplam veya toplam tutar şeklinde farklı tutar alanları bulunmaktadır. Fatura sorgularken ödenecek Tutar bilgisinin ve bu tutarın kuruş hanelerinin doğru girildiğinden emin olunuz.
                        </li>
                        <li>
                            <div className="icon circle flat" />
                            Güvenlik kodu karmaşık harf ve sayılardan oluştuğundan bu diziyi doğru bir şekilde girdiğinizden emin olunuz. Eğer güvenlik kodunu okumakta zorlanıyorsanız yenile butonu ile değeri yenileyiniz.
                        </li>
                    </ul>
                </div>
                <div className="query-form-container-footer">
                    <input tabIndex="10" type="button" value="Fatura Sorgula" onClick={ () => startQuery() } className="simpra-button pink-shadow" disabled={ accessTokenHandler.isPending || invoiceQueryHandler.isPending } />

                </div>
            </div>
        </div>
    )
}

export default QueryForm